//
// AUTO-GENERATED FILE. DO NOT MODIFY.
//
// This class was automatically generated by Apollo GraphQL version '4.3.3'.
//
package com.wintermar.inspection.graphql

import com.apollographql.apollo.annotations.ApolloAdaptableWith
import com.apollographql.apollo.api.Adapter
import com.apollographql.apollo.api.CompiledField
import com.apollographql.apollo.api.CustomScalarAdapters
import com.apollographql.apollo.api.Mutation
import com.apollographql.apollo.api.json.JsonWriter
import com.apollographql.apollo.api.obj
import com.wintermar.inspection.graphql.adapter.DeleteInspectionReportMutation_ResponseAdapter
import com.wintermar.inspection.graphql.adapter.DeleteInspectionReportMutation_VariablesAdapter
import com.wintermar.inspection.graphql.selections.DeleteInspectionReportMutationSelections
import com.wintermar.inspection.graphql.type.DeleteInspectionReportCommandInput
import kotlin.Any
import kotlin.Boolean
import kotlin.String
import com.wintermar.inspection.graphql.type.Mutation as CompiledMutation

public data class DeleteInspectionReportMutation(
  public val deleteInspectionReportCommandInput: DeleteInspectionReportCommandInput,
) : Mutation<DeleteInspectionReportMutation.Data> {
  override fun id(): String = OPERATION_ID

  override fun document(): String = OPERATION_DOCUMENT

  override fun name(): String = OPERATION_NAME

  override fun serializeVariables(
    writer: JsonWriter,
    customScalarAdapters: CustomScalarAdapters,
    withDefaultValues: Boolean,
  ) {
    DeleteInspectionReportMutation_VariablesAdapter.serializeVariables(writer, this, customScalarAdapters, withDefaultValues)
  }

  override fun adapter(): Adapter<Data> = DeleteInspectionReportMutation_ResponseAdapter.Data.obj()

  override fun rootField(): CompiledField = CompiledField.Builder(
    name = "data",
    type = CompiledMutation.type
  )
  .selections(selections = DeleteInspectionReportMutationSelections.__root)
  .build()

  @ApolloAdaptableWith(DeleteInspectionReportMutation_ResponseAdapter.Data::class)
  public data class Data(
    public val deleteInspectionReport: Any,
  ) : Mutation.Data

  public companion object {
    public const val OPERATION_ID: String =
        "c989cc6a639fd324343e4d82e495f6e6be4ef9b09a7f6066d956170a20eaf4f9"

    /**
     * The minimized GraphQL document being sent to the server to save a few bytes.
     * The un-minimized version is:
     *
     * ```
     * mutation deleteInspectionReport($deleteInspectionReportCommandInput: DeleteInspectionReportCommandInput!) {
     *   deleteInspectionReport(command: $deleteInspectionReportCommandInput)
     * }
     * ```
     */
    public val OPERATION_DOCUMENT: String
      get() = "mutation deleteInspectionReport(${'$'}deleteInspectionReportCommandInput: DeleteInspectionReportCommandInput!) { deleteInspectionReport(command: ${'$'}deleteInspectionReportCommandInput) }"

    public const val OPERATION_NAME: String = "deleteInspectionReport"
  }
}
